import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_CONSULTA_CUPO } from '../../../../config/forms'
import { Button } from 'react-bootstrap'
import CamposConsultaCupo from '../../components/consultas/CamposConsultaCupo'
import Consulta from '../../components/consultas/Consulta'
import * as actions from '../../actions'
import { toast, ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { IconButton, CircularProgress, Dialog, DialogContent } from '@material-ui/core'
import ScannerQR from '../../../Scanner/containers/ScannerQR'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AnnouncementIcon from '@material-ui/icons/Announcement'

const selector = formValueSelector(FORM_CONSULTA_CUPO)

class FormConsultaCupo extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSubmitQR = this.handleSubmitQR.bind(this)
    this.handleResetConsultaCupo = this.handleResetConsultaCupo.bind(this)
    this.getTurnosPendientes = this.getTurnosPendientes.bind(this)
    this.getTotalCamiones = this.getTotalCamiones.bind(this)
    this.getCamionesPedidos = this.getCamionesPedidos.bind(this)
    this.getCortes = this.getCortes.bind(this)
    this.openQR = this.openQR.bind(this)
    this.closeQR = this.closeQR.bind(this)
    this.setProcesando = this.setProcesando.bind(this)
    this.openDialogNotificaciones = this.openDialogNotificaciones.bind(this)
    this.handleCloseNotificacion = this.handleCloseNotificacion.bind(this)
    this.state = { showQR: false }
    this.state = { procesando: false }
    this.state = { notificacion: '' }
    this.state = { viewNotificacion: false }
  }

  componentDidMount () {
    this.props.getNotificacionesChofer()
  }

  handleSubmit (e) {
    const { numero } = this.props
    e.preventDefault()
    if (!isNaN(numero) && (String(numero).length === 11)) {
      this.props.submitConsultaCupo(numero)
      this.setProcesando(true)
    } else {
      toast.error('Número incorrecto')
    }
  }

  handleSubmitQR (numero) {
    const { change: formChange } = this.props
    if (!isNaN(numero) && (String(numero).length === 11)) {
      this.props.submitConsultaCupo(numero)
      this.setProcesando(true)
    } else {
      formChange('numero', '')
      toast.error('Número incorrecto')
    }
    this.closeQR()
  }

  handleResetConsultaCupo () {
    const { change: formChange } = this.props
    this.props.resetConsultaCupo()
    this.setProcesando(false)
    formChange('numero', '')
  }

  getTurnosPendientes (turno, cereal) {
    this.props.getTurnosPendientesEgreso(turno, cereal)
  }

  getTotalCamiones () {
    this.props.getCamionesTotal()
  }

  getCamionesPedidos () {
    this.props.getPedidosPlaya()
  }

  getCortes () {
    this.props.getCortesPedidos()
  }

  openQR () {
    this.setState({ showQR: true })
  }

  closeQR () {
    this.setState({ showQR: false })
  }

  setProcesando (newValue) {
    this.setState({ procesando: newValue })
  }

  openDialogNotificaciones (notificacion) {
    const { change: formChange } = this.props
    formChange('notificacionCompleta', notificacion)
    this.setState({ viewNotificacion: true })
  }

  handleCloseNotificacion () {
    const { change: formChange } = this.props
    formChange('notificacionCompleta', '')
    this.setState({ viewNotificacion: false })
  }

  render () {
    const {
      cpaConsultaCupo,
      notificacionesChofer,
      notificacionCompleta
    } = this.props

    let notificacion, notificacion2
    if (notificacionesChofer) {
      const notificacionesPrioridad = notificacionesChofer.sort((a, b) => b.prioridad - a.prioridad)
      // notificacion = notificacionesPrioridad[0].notificacion
      if (notificacionesPrioridad.length > 1) {
        notificacion = notificacionesPrioridad[0].notificacion
        notificacion2 = notificacionesPrioridad[1].notificacion
      } else if (notificacionesPrioridad.length > 0) {
        notificacion = notificacionesPrioridad[0].notificacion
      }
    }

    return (
      <div>
        {(!this.state.showQR) && <div className='container-consulta-numero'>
          <ToastContainer autoClose={INTERVALO_CORTO} />
          {!cpaConsultaCupo && <div className='container-imagen-consulta-chofer'>
            <Dialog
              open={this.state.viewNotificacion}
              onClose={this.handleCloseNotificacion}
              fullWidth
              maxWidth='xl'
            >
              <div className='header-dialog-notificacion'>
                <AnnouncementIcon style={{ fontSize: 40 }} className='icon-notificacion-chofer-dialog' />
              </div>
              <DialogContent className='content-dialog-notificacion'>
                {notificacionCompleta}
              </DialogContent>
              <div style={{ margin: '5%' }}>
                <Button variant='link' onClick={this.handleCloseNotificacion} className='small-notificaciones'>
                      Cerrar
                </Button>
              </div>
            </Dialog>
            { notificacion && <div className='container-notificaciones-chofer'>
              <div className='notificacion-body'>
                <AnnouncementIcon style={{ fontSize: 40 }} className='icon-notificacion-chofer' />
                <p className='mensaje-novedades-chofer'>{notificacion}</p>
              </div>
              <div>
                <Button variant='link' onClick={() => this.openDialogNotificaciones(notificacion)} className='small-notificaciones'>
                  <small>Leer mensaje completo</small>
                </Button>
              </div>
            </div> }
            { notificacion2 && <div className='container-notificaciones-chofer' style={{ marginBottom: '0' }}>
              <div className='notificacion-body'>
                <AnnouncementIcon style={{ fontSize: 40 }} className='icon-notificacion-chofer' />
                <p className='mensaje-novedades-chofer'>{notificacion2}</p>
              </div>
              <div>
                <Button variant='link' onClick={() => this.openDialogNotificaciones(notificacion2)} className='small-notificaciones'>
                  <small>Leer mensaje completo</small>
                </Button>
              </div>
            </div> }
            <div id='form-consulta-cupo'>
              <form onSubmit={this.handleSubmit}>
                <h5 style={{ fontSize: '1.8rem', textAlign: 'center', margin: '0 2%', color: '#ffffff', fontWeight: '500' }}>
                  <strong>Consulte con su número de CTG</strong>
                </h5>
                <CamposConsultaCupo />
                {!cpaConsultaCupo && this.state.procesando && <div className='circular-progress-consulta-chofer'>
                  <CircularProgress color='inherit' />
                  <h4 style={{ margin: '15px ', fontSize: '1.3rem' }}>Procesando sus datos</h4>
                </div>}
                <div style={{ width: '67%', float: 'left' }}>
                  <Button
                    type='submit'
                    size='lg'
                  >Consultar</Button>
                </div>
              </form>
              <IconButton style={{ backgroundColor: '#007bff', float: 'left' }} onClick={this.openQR}>
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='#ffffff' className='bi bi-qr-code' viewBox='0 0 16 16'>
                  <path d='M2 2h2v2H2V2Z' />
                  <path d='M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z' />
                  <path d='M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z' />
                  <path d='M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z' />
                  <path d='M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z' />
                </svg>
              </IconButton>
            </div>
          </div>}
          <div id='text-consulta-cupo' className='container-consulta'>
            {cpaConsultaCupo && <Consulta cpaConsultaCupo={cpaConsultaCupo} handleReset={this.handleResetConsultaCupo} getTurnosPendientes={this.getTurnosPendientes} getTotalCamiones={this.getTotalCamiones} getCamionesPedidos={this.getCamionesPedidos} getCortes={this.getCortes} /> }
          </div>
        </div> }
        { this.state.showQR && <div>
          <div className='titulo-en-cabecera'>
            <IconButton onClick={this.closeQR}><ArrowBackIcon /></IconButton>
          </div>
          <div style={{ margin: '2% 0' }}>
            <ScannerQR handleSubmit={this.handleSubmitQR} />
          </div>
        </div> }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  camionesCircuito: state.camionesIngreso.totalCamiones || {},
  cpaConsultaCupo: state.camionesIngreso.cpaConsultaCupo,
  notificacionesChofer: state.camionesIngreso.notificacionesChofer,
  notificacionCompleta: selector(state, 'notificacionCompleta'),
  numero: selector(state, 'numero')
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(
  reduxForm({ form: FORM_CONSULTA_CUPO })(FormConsultaCupo)
)
